import { partnerImagesStoreService } from 'legacy/lut/classes/services/PartnerImagesStoreService'
import { useEffect, useState } from 'react'

import { IForm } from 'core-components/classes/models/IForm'

export const usePartnerImages = (partnerId: string, ImageType: string, isForced = false) => {
  const [gallery, setGallery] = useState<IForm[]>([] as IForm[])
  const [logo, setLogo] = useState<IForm[]>([] as IForm[])
  const [banner, setBanner] = useState<IForm[]>([] as IForm[])

  const fetchGallery = async (PartnerId: string) => {
    const data = await partnerImagesStoreService.getImages(PartnerId, isForced)
    if (data && data.length > 0) {
      const logoIndex = data.findIndex((item: any) => item.ImageType === 'Logo')
      if (logoIndex >= 0) {
        setLogo(data[logoIndex])
        data.splice(logoIndex, 1)
      }
      const bannerIndex = data.findIndex((item: any) => item.ImageType === 'Banner')
      if (bannerIndex >= 0) {
        setBanner(data[bannerIndex])
        data.splice(bannerIndex, 1)
      }
      data && setGallery([...data])
    }
  }

  useEffect(() => {
    fetchGallery(partnerId)
  }, [partnerId])

  useEffect(() => {
    isForced && fetchGallery(partnerId)
  }, [isForced])

  switch (ImageType) {
    case 'Logo':
      return logo
    case 'Banner':
      return banner
    default:
      return gallery
  }
}
